import React from "react";
function Answer()
{
    return(
        <>
        <h2>Answer Ticket Support</h2>
        </>
    )
}
export default Answer;